import React from 'react';

const ImmediateActionSection = ({ value, onChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Immediate Actions Taken</h3>
      <textarea
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Describe any immediate corrective actions taken on-site to address the observation..."
        className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
        rows={4}
      />
    </div>
  );
};

export default ImmediateActionSection;